import store from '@/app/store';
import { computed } from '@vue/composition-api';

export function useCart() {
    const cartLimit = 5;

    const cart = computed(() => store.state.sharing.cart);
    const cartAssetIds = computed(() => cart.value.map((asset: any) => asset.id));

    const clearCart = () => {
        store.commit.sharing.CLEAR_CART();
        localStorage.setItem('cart', JSON.stringify([]));
    };

    const getCartFromLocalStorage = () => {
        const cartAssets: any = localStorage.getItem('cart');
        if (cartAssets) return JSON.parse(cartAssets);
        return [];
    };

    store.commit.sharing.SET_CART(getCartFromLocalStorage());

    const addToCart = (asset: any) => {
        if (cart.value.length >= cartLimit) return;
        store.commit.sharing.ADD_TO_CART(asset);
        localStorage.setItem('cart', JSON.stringify(cart.value));
    };

    const removeFromCart = (assetId: number) => {
        store.commit.sharing.REMOVE_FROM_CART(assetId);
        localStorage.setItem('cart', JSON.stringify(cart.value));
    };

    return {
        cartLimit,
        cart,
        cartAssetIds,
        addToCart,
        removeFromCart,
        clearCart,
    };
}
